import {useWorkflowIds} from "../../common/OrganizationConfig/useWorkflowIds";
import {CitiesGetValues, useGetCitiesMutation} from "./cities-api";

export const useGetCities = () => {
  const {getCitiesWorkflowId} = useWorkflowIds();
  const [trigger, result] = useGetCitiesMutation();

  const getCities = (queryValues: CitiesGetValues) => {
    return trigger({
      workflowId: getCitiesWorkflowId,
      values: {
        variables: {
          ...queryValues,
        },
      },
    });
  };

  return [getCities, result] as const;
};
